export default {
  RENDER_IN_PLACE: 'DashGridEvents:RENDER_IN_PLACE',
}
